import { ReactNode } from "react";
import { Card } from "shared/components/Card";

interface SectionCardProps {
  title: string;
  subtitle?: string;
  description?: ReactNode;
  children: ReactNode;
  headerExtra?: ReactNode;
  footer?: ReactNode;
  noPadding?: boolean;
}

export const SectionCard = ({
  title,
  subtitle,
  description,
  children,
  headerExtra,
  footer,
  noPadding
}: SectionCardProps) => {
  return (
    <Card>
      <div className="px-8 border-b border-alpha-40 flex items-center justify-between gap-4">
        <div className={subtitle ? "py-4" : "py-6"}>
          <h3 className="text-base font-bold text-content-1000">{title}</h3>
          {subtitle ? (
            <p className="text-sm text-content-600 mt-2 font-medium">
              {subtitle}
            </p>
          ) : null}
          {description}
        </div>
        {headerExtra}
      </div>
      <div className={noPadding ? "" : "py-6 px-8"}>
        {children}
        {footer}
      </div>
    </Card>
  );
};
